export default "__VITE_ASSET__DmhgaxaB__"